let overlay = null;

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  const mount = () => {
    if (!overlay || overlay.isConnected) return;
    toggleLoadingSpinner(image);
    // Append to body so sticky header (z-index 200) cannot cover the zoom
    document.body.appendChild(overlay);
    document.body.classList.add('ff-magnify-open');
    image.style.opacity = '100%';
  };

  overlayImage.onload = mount;
  overlayImage.src = image.src;
  // Cached images may not fire onload if complete already
  if (overlayImage.complete) mount();

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithPointer(image, clientX, clientY, zoomRatio) {
  if (!overlay) return;

  const ratio = image.height / image.width;
  const container = overlay.getBoundingClientRect();
  const xPosition = clientX - container.left;
  const yPosition = clientY - container.top;
  const xPercent = `${xPosition / (container.width / 100)}%`;
  const yPercent = `${yPosition / ((container.width * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${Math.max(image.width, container.width) * zoomRatio}px`;
}

function moveWithHover(image, event, zoomRatio) {
  moveWithPointer(image, event.clientX, event.clientY, zoomRatio);
}

function closeOverlay() {
  if (!overlay) return;
  overlay.remove();
  overlay = null;
  document.body.classList.remove('ff-magnify-open');
}

function magnify(image, zoomRatio) {
  if (overlay) closeOverlay();

  const current = createOverlay(image);

  current.onclick = () => closeOverlay();

  current.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  current.onmouseleave = () => closeOverlay();

  current.ontouchmove = (event) => {
    if (!event.touches || !event.touches[0]) return;
    event.preventDefault();
    const touch = event.touches[0];
    moveWithPointer(image, touch.clientX, touch.clientY, zoomRatio);
  };
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
